import { MRT_ColumnDef } from 'mantine-react-table'
import { Text } from '@mantine/core'
import { ReactNode } from 'react'
import { HolidayCalendarParams } from 'app/models/holiday-calendar-params'
import HolidayCalendarActions from './holiday-calendar-actions'
import Pill, { PillColor } from 'app/views/components/Table/Pill'
import CustomHoverCard from 'app/views/components/popover/custom-hover-card'
import { ReactComponent as InfoIcon } from '../../../public/generic-icons/info-icon.svg'

enum StatusState {
  Active = 'Active',
  Inactive = 'Inactive',
}

const getPillColor = new Map<StatusState, PillColor>()
getPillColor.set(StatusState.Active, PillColor.GREEN)
getPillColor.set(StatusState.Inactive, PillColor.RED)


function TableHead({ header }: { header: string }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {header}
    </Text>
  )
}

function TableRowText({ text }: { text: ReactNode }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {text}
    </Text>
  )
}
export function getColumnDefs(
  setOpenHolidayCalendar: React.Dispatch<React.SetStateAction<boolean>>,
  setCurrentCalendar: React.Dispatch<React.SetStateAction<HolidayCalendarParams | undefined>>,
): MRT_ColumnDef<HolidayCalendarParams>[] {
  return [
    {
      size: 100,
      accessorKey: 'name',
      header: 'Calendar',
      Header: <TableHead header={'Calendar'} />,
      Cell: ({ cell }) => (
        <TableRowText text={cell.getValue<string>()} />
      ),
    },
    {
      size: 50,
      accessorKey: 'year',
      header: 'Year',
      Header: <TableHead header={'Year'} />,
      filterVariant: 'range',
      Cell: ({ cell }) => (
        <TableRowText text={cell.getValue<string>()} />
      ),
    },
    {
      size: 50,
      accessorKey: 'status',
      header: 'Status',
      Header: <TableHead header={'Status'} />,
      Cell: ({ cell }) => {
        const color: PillColor =
          getPillColor.get(cell.getValue<string>() as StatusState) ?? PillColor.GREY
        return <Pill outlined text={(cell.getValue<string>() as string) ?? ''} color={color} />
      },
    },

    {
      size: 50,
      header: 'Alerts',
      Header: <TableHead header={'Alerts'} />,
      Cell: ({ row }) => {
        const lstaTradeCalcs = row.original.lstaTradeCalcs;
        const lmaTradeCalcs = row.original.lmaTradeCalcs;
        const systemDate = row.original.systemDate;
        const lstaTradeCalcsMessage = lstaTradeCalcs ? 'LSTA Trade Calculations' : ''
        const lmaTradeCalcsMessage = lmaTradeCalcs ? 'LMA Trade Calculations' : ''
        const systemDateMessage = systemDate ? 'System Date' : ''
        const alertMessage = "Used for " + ([lstaTradeCalcsMessage, lmaTradeCalcsMessage, systemDateMessage].filter(Boolean).join(', '))

        if (!lstaTradeCalcs && !lmaTradeCalcs && !systemDate) {
          return <></>
        }
        return (
          <CustomHoverCard
            cardTitle='Info'
            position='right'
            targetComponent={
              <InfoIcon style={{ width: '20px', height: '20px' }} />
            }
          >
            <Text className='hover-card-alert-text'>
              {alertMessage}
            </Text>
          </CustomHoverCard>
        )
      },
    },
    {
      size: 50,
      accessorKey: 'id',
      header: 'Actions',
      Header: <TableHead header={'Actions'} />,
      enableColumnActions: false,
      enableColumnFilter: false,
      Cell: cell => (
        <HolidayCalendarActions
          row={cell.row.original}
          setCurrentCalendar={setCurrentCalendar}
          setOpenHolidayCalendar={setOpenHolidayCalendar}
        />
      ),
    },
  ]
}
